function CacheLoaing () {
    return(
        <div>LOADING</div>
    );
}

export default CacheLoaing;